<template>
  <div class="section">
    <div class="doc">
      <div class="max-width">
        <div class="doc__block">

          <div class="doc__top">
            <div class="doc__about">
              <div class="doc__title">
                One-of-a-Kind Support You Can Rely On
              </div>
              <div class="doc__text">
                Our team is here to help on business days, with typical response times of 15 minutes during support hours, even during your trial. Choose the option that works best for you.
              </div>
            </div>

            <div class="doc__image">
              <img loading="lazy" srcset="/assets/imgs/themes/zap/doc/doc.webp 1x, /assets/imgs/themes/zap/doc/doc@2x.webp 2x" src="/assets/imgs/themes/zap/doc/doc.webp">
            </div>
          </div>

          <div class="doc__actions">
            <div class="doc__column">
              <div class="doc__item">
                <div class="doc__head">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 10C15.9915 10 9.5 15.516 9.5 22.32C9.5 26.0922 11.5003 29.4639 14.6434 31.7241C14.7237 33.4444 14.4582 35.8198 12.0946 36.915C11.8784 36.9976 11.731 37.2077 11.7308 37.44C11.7308 37.7493 11.9805 38 12.2885 38C12.3045 38 12.3205 37.9992 12.3364 37.9978C15.0513 37.9803 17.356 36.5071 18.9459 34.9506C19.4501 34.4567 20.1529 34.2136 20.8456 34.3447C21.8606 34.5384 22.9158 34.64 24 34.64C32.0085 34.64 38.5 29.124 38.5 22.32C38.5 15.516 32.0085 10 24 10Z" fill="white" />
                  </svg>

                  <div class="doc__label">
                    Live Chat
                    <span>Online <em>•</em></span>
                  </div>

                  <div class="doc__desc">
                    Real-time help from our Support team
                  </div>
                </div>

                <div class="doc__button">
                  <a href="#" id="launchChat" class="doc__start">
                    Start a Live Chat
                  </a>
                </div>
              </div>
            </div>

            <div class="doc__column">
              <div class="doc__item">
                <div class="doc__head">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_244_9004)">
                      <path d="M11.4781 11.4766C10.0224 11.4766 8.80519 12.4829 8.45771 13.8305L23.9998 23.5703L39.5511 13.858C39.213 12.4947 37.9882 11.4766 36.5216 11.4766H11.4781ZM8.34766 17.3217V33.3896C8.34766 35.116 9.75166 36.52 11.4781 36.52H36.5216C38.248 36.52 39.652 35.116 39.652 33.3896V17.3553L23.9998 27.1287L8.34766 17.3217Z" fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_244_9004">
                        <rect width="48" height="48" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  <div class="doc__label">
                    Submit Tickets
                  </div>

                  <div class="doc__desc">
                    Request a Fix or Customization
                  </div>
                </div>

                <div class="doc__button">
                  <a
                      href="https://ashstonestudios.zendesk.com/hc/en-us/articles/32061722600082-Get-Support"
                      target="_blank"
                      rel="noopener noreferrer"
                  >
                    Send a request
                  </a>
                </div>
              </div>
            </div>

            <div class="doc__column">
              <div class="doc__item">
                <div class="doc__head">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_244_8994)">
                      <path d="M28.5952 9.81603C27.6575 8.87835 26.3857 8.35156 25.0596 8.35156H14.609C12.8872 8.35156 11.4785 9.76026 11.4785 11.482V36.5255C11.4785 38.2472 12.8872 39.6559 14.609 39.6559H33.3916C35.1133 39.6559 36.522 38.2472 36.522 36.5255V19.8139C36.522 18.4879 35.9952 17.2161 35.0575 16.2784L28.5952 9.81603ZM30.2611 31.8298C30.2611 32.6943 29.5604 33.395 28.6959 33.395H19.3046C18.4402 33.395 17.7394 32.6943 17.7394 31.8298C17.7394 30.9654 18.4402 30.2646 19.3046 30.2646H28.6959C29.5604 30.2646 30.2611 30.9654 30.2611 31.8298ZM30.2611 25.569C30.2611 26.4334 29.5604 27.1342 28.6959 27.1342H19.3046C18.4402 27.1342 17.7394 26.4334 17.7394 25.569C17.7394 24.7045 18.4402 24.0037 19.3046 24.0037H28.6959C29.5604 24.0037 30.2611 24.7045 30.2611 25.569Z" fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_244_8994">
                        <rect width="48" height="48" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  <div class="doc__label">
                    Documentation
                  </div>

                  <div class="doc__desc">
                    How-to guidance for theme setup and use
                  </div>
                </div>

                <div class="doc__button">
                  <a
                      href="https://ashstonestudios.zendesk.com/hc/en-us/categories/31714411688466-Zap"
                      target="_blank"
                      rel="noopener noreferrer"
                  >
                    View Documentation
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocView',
  props: {
    docLink: { type: String, required: true },
    imgMain: { type: String, required: true },
    imgSet: { type: String, required: false },
    imgAlt: { type: String, required: false }
  },

  mounted() {
    const launcherChat = document.getElementById('launchChat')
    if (!launcherChat) return

    this.handleClick = (e) => {
      e.preventDefault()
      if (window.zE && typeof window.zE === 'function') {
        window.zE('messenger', 'open')
      }
    }

    launcherChat.addEventListener('click', this.handleClick)

    if (window.zE && typeof window.zE === 'function') {
      window.zE('messenger:on', 'close', () => {
        console.log('Messenger closed')
      })
    }
  },

  beforeUnmount() {
    const launcherChat = document.getElementById('launchChat')
    if (launcherChat && this.handleClick) {
      launcherChat.removeEventListener('click', this.handleClick)
    }
  }
}
</script>


<style lang="scss">
.doc {
  background:#07071C;
  color:#fff;
  padding:4rem 0;

  &__top {
    display:flex;
    align-items:center;
    gap:3rem;
    justify-content:space-between;

    @include md {
      flex-direction:column-reverse;
    }
  }

  &__about {
    max-width:600px;
    text-align:center;
    width:100%;
  }

  &__title {
    font-weight: 900;
    font-size: 3rem;
    line-height: .9;
    letter-spacing: -0.02em;
    max-width:500px;
    margin:0 auto;
    text-transform: uppercase;

    @include lg {
      font-size:2rem;
    }
  }

  &__text {
    margin:1.5rem 0 0;
    font-size:1.25rem;
    font-weight:500;
    color:#fff;
    line-height:1.4;

    @include lg {
      font-size:1rem;
    }
  }

  &__image {
    flex:none;
    max-width:800px;

    @include xl {
      flex:auto;
    }

    @include md {
      max-width:450px;
    }
  }

  &__actions {
    display:grid;
    grid-template-columns:repeat(3,1fr);
    gap:1.5rem;
    margin-top:3.5rem;

    @include md {
      grid-template-columns:repeat(1,1fr);
    }

    @include xs {
      margin-top:2rem;
    }
  }

  &__column {
    position:relative;
    border-radius:24px;
    background: #1A1A2E;
    overflow:hidden;
    padding:1px;

    @include xs {
      border-radius:16px;
    }

    &:first-child {
      &:before {
        content: '';
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        background: conic-gradient(rgba(84,220,147,0), rgba(84,220,147,1), rgba(84,220,147,0) 30%);
        animation: rotateBorder 4s linear infinite;
        z-index: 1;
      }
    }
  }

  @keyframes rotateBorder {
    100% {
      transform: rotate(360deg);
    }
  }

  &__item {
    background: #1A1A2E;
    padding:1.5rem;
    border-radius:24px;
    position:relative;
    z-index:2;
    height:100%;
    display:flex;
    flex-direction:column;
    justify-content:space-between;

    @include xs {
      padding:1.125rem;
      border-radius:16px;
    }
  }

  &__head {
    margin-bottom:3rem;
    position:relative;
    padding-left:58px;

    @include xs {
      margin-bottom:1rem;
    }

    svg {
      position:absolute;
      left:0;
      top:0;
    }
  }

  &__label {
    font-size: 1.125rem;
    line-height: 1;
    letter-spacing: -0.02em;
    display:flex;
    align-items:center;
    gap:10px;
    font-weight: 900;
    text-transform: uppercase;

    span {
      font-weight: 500;
      font-size: 12px;
      text-transform:none;
      color: #54dc93;
      display:flex;
      align-items:center;
      gap:4px;

      em {
        font-size:1rem;
        font-style:normal;
        animation:onlineBlink 1s linear infinite;
      }

      @keyframes onlineBlink {
        0%, 100%{
          opacity:0;
        }

        50% {
          opacity:1;
        }
      }
    }
  }

  &__desc {
    margin:.25rem 0 0;
    font-weight: 500;
    font-size: .875rem;
    line-height: 1.4;
    opacity:.7;
    color:#fff;
  }

  &__button {
    a {
      height:3.5rem;
      display:flex;
      align-items:center;
      justify-content:center;
      border-radius:16px;
      padding:0 1.25rem;
      background: rgba(255, 255, 255, 0.12);
      font-weight: 600;
      font-size: 1rem;
      line-height: 1.2;
      transition:.3s ease-out;
      letter-spacing: 0em;
      text-transform:uppercase;
      color:#fff;

      @include xs {
        height:3rem;
        font-size:.875rem;
        border-radius:12px;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.2);
      }
    }
  }

  &__start {
    background:#fff !important;
    color:var(--color-main) !important;

    &:hover {
      background:#eee !important;
    }
  }
}
</style>
